import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginForm, OTPVerification, useAuth } from "@project-mgmt/feature-auth";
import { toast } from "react-toastify";
import React from "react";
import { routes } from "../utils/routes";

export function LoginPage() {
  const [step, setStep] = useState<"phone" | "otp">("phone");
  const [phoneNumber, setPhoneNumber] = useState("");
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(routes.workspaces());
    }
  }, [isAuthenticated, navigate]);

  const handleLoginSuccess = (phone: string) => {
    setPhoneNumber(phone);
    setStep("otp");
    toast.success("OTP sent successfully!");
  };

  const handleLoginError = (error: string) => {
    toast.error(error);
  };

  const handleOTPSuccess = () => {
    toast.success("Login successful!");
    navigate(routes.workspaces());
  };

  const handleOTPError = (error: string) => {
    toast.error(error);
  };

  const handleBack = () => {
    setStep("phone");
    setPhoneNumber("");
  };

  return (
    <div className="auth-shell">
      <div className="auth-shell-inner">
        <div className="auth-brand">
          <div className="auth-brand-mark">VB</div>
          <h1 className="auth-brand-title">
            Venture <span className="auth-brand-title-accent">Builders</span>
          </h1>
          <p className="mt-2 text-base text-textSecondary">Sign in to your account</p>
        </div>

        <div className="card-base auth-frame">
          {step === "phone" ? (
            <>
              <h2 className="mb-6 text-center text-xl font-bold text-textPrimary">Enter Phone Number</h2>
              <LoginForm onSuccess={handleLoginSuccess} onError={handleLoginError} className="auth-form" />
            </>
          ) : (
            <OTPVerification
              phoneNumber={phoneNumber}
              onSuccess={handleOTPSuccess}
              onError={handleOTPError}
              onBack={handleBack}
              className="auth-form"
            />
          )}
        </div>
      </div>
    </div>
  );
}
